export const exchangeRateWarningTranslationKeys = {
  bankLines: {
    higher: 'subject.payment_reconcile.cross_currency.exchange_warning.higher',
    lower: 'subject.payment_reconcile.cross_currency.exchange_warning.lower',
  },
  manualPayment: {
    higher: 'subject.payment_reconcile.cross_currency.exchange_warning.manualPayment.higher',
    lower: 'subject.payment_reconcile.cross_currency.exchange_warning.manualPayment.lower',
  },
} as const
